export const environment = {
    production: true,
    apiUri: 'https://miaas-api.dataanalysis.fb01.h-brs.de',
    supabaseUrl: 'https://zzxxfqauniebwwihdpzp.supabase.co',
    supabaseKey:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6eHhmcWF1bmllYnd3aWhkcHpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTI1NjA5NDcsImV4cCI6MjAyODEzNjk0N30.EsGRZ_ABZO0YyfnUpjZZ4dJQxNJCgYHYs_1DNMOjqbY'
};
